function initTentativeShimmer() {
    const cards = document.querySelectorAll('.is-tentative');
    if (!cards.length) return;

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('shimmer-active');
                obs.unobserve(entry.target);
            }
        });
    }, { threshold: 0.1 });

    cards.forEach(card => observer.observe(card));
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTentativeShimmer);
} else {
    initTentativeShimmer();
}
